import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable()
export class UsersApiService {
  private readonly apiBaseUrl: string;

  constructor(private http: HttpClient) {
    this.apiBaseUrl = environment.serverURI + '/pos/api';
  }

  public getUsers(searchText: string, searchedRole: string) {
    let params: HttpParams = new HttpParams();
    params = params.set('search', encodeURIComponent(searchText));
    params = params.set('roles', searchedRole);
    params = params.set('showLoader', 'false');
    return this.http.get(`${this.apiBaseUrl}/wizeusers/search`, { params });
  }
}
